<template>
  <div class="absolute inset-y-0 left-0 pt-6 pl-3" style="height: 300px;">

    <div class="group flex items-center cursor-pointer" @click="showNoticeModal = true, showControlMap = false">
      <div
        v-bind:class="showNoticeModal ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
      <svg aria-hidden="true" focusable="false" data-icon="file-alt" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"></path></svg>
      </div>
      <div
        v-bind:class="showNoticeModal ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Nuevo</div>
    </div>
    <notice-modal 
      :showing="showNoticeModal" 
      :geometries="geometries" 
      @close="showNoticeModal = false"
      @createNew = "createNew()">
    </notice-modal>

    <div class="group flex items-center cursor-pointer mt-2" @click="showProjectModal = true, showControlMap = false">
      <div
        v-bind:class="showProjectModal ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
      <svg aria-hidden="true" focusable="false" data-icon="save" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"></path></svg>
      <!-- <svg aria-hidden="true" focusable="false" data-icon="file-alt" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"></path></svg> -->
      </div>
      <div
        v-bind:class="showProjectModal ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Guardar</div>
    </div>
    <project-modal 
      :showing="showProjectModal" 
      :geometries="geometries"
      @close="showProjectModal = false"
      @saved="savedSuccesfully()"

      @trigger-alert="showAlert"
    ></project-modal>

    <BaseAlert
      v-if="alert.visible"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      :dismissible="true"
      :auto-close="false"
      :close-on-backdrop="true"
      @closed="alert.visible = false"
    />

    <div
      class="group flex items-center cursor-pointer mt-2"
      @click="showControlMap = !showControlMap"
    >
      <div
        v-bind:class="showControlMap ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current text-gray-100"
          viewBox="0 0 22 22"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
          />
        </svg>
      </div>
      <div
        v-bind:class="showControlMap ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Tipo de mapa</div>
    </div>
    <control-map :showing="showControlMap" @click="changeMapLayer"></control-map>

<!--     <div class="group flex items-center cursor-pointer mt-2" @click="guardarConflicto">
      <div
        v-bind:class="showComplaints ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg class="h-6 w-6 fill-current text-gray-100" viewBox="0 0 24 24">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      </div>
      <div
        v-bind:class="showComplaints ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Guardar</div>
    </div> -->
<!-- 
    <div class="group flex items-center cursor-pointer mt-2" @click="layerUsers">
      <div
        v-bind:class="showUsers ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg class="h-6 w-6 fill-current text-gray-100" viewBox="0 0 24 24">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>
        </svg>
      </div>
      <div
        v-bind:class="showUsers ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Visitantes</div>
    </div>

    <div class="group flex items-center cursor-pointer mt-2" @click="layerAuthorities">
      <div
        v-bind:class="showAuthorities ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg class="h-6 w-6 fill-current text-gray-100" viewBox="0 0 24 24">
          <path
            d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </div>
      <div
        v-bind:class="showAuthorities ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Autoridades</div>
    </div>

    
    <div class="group flex items-center cursor-pointer mt-2" @click="layerHeatMapComplaints">
      <div
        v-bind:class="showHeatMapComplaints ? 'bg-red-500 group-hover:bg-cdmx-red' : 'bg-cdmx-green group-hover:bg-cdmx-green-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg class="h-6 w-6 fill-current text-gray-100" viewBox="0 0 24 24">

          <path fill="none" d="M0 0h24v24H0z"/><path d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"/>
          <path fill="none" d="M0 0h24v24H0z"/>
        </svg>
      </div>
      <div
        v-bind:class="showHeatMapComplaints ? 'bg-cdmx-red' : 'bg-cdmx-green-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Mapa de calor de denuncias</div>
    </div> -->
  </div>
</template>
<script>
import noticeModal from "./NoticeModal";
import projectModal from "./ProjectModal";
import controlMap from "./ControlMap";
import BaseAlert from "./atoms/BaseAlert.vue";

export default {
  name: "Button",
  data() {
    return {
      showNoticeModal: false,
      showProjectModal: false,
      showControlMap: false,
      alert: {
        visible: false,
        type: '',
        title: '',
        message: '',
      },
    };
  },
  mounted() {},
  components: {
    noticeModal,
    projectModal,
    controlMap,
    BaseAlert
  },
  methods: {
    //  guardarConflicto(){
    //    console.log("guardar conflicto")
    //  },
    // layerUsers() {
    //   this.$emit("changeUsers", !this.showUsers);
    // },
    // layerAuthorities() {
    //   this.$emit("changeAuthorities", !this.showAuthorities);
    // },
    // layerHeatMapComplaints(){
    //   this.$emit("changeHeatMapComplaints", !this.showHeatMapComplaints);
    // },
    changeMapLayer(map) {
      this.$emit("click", map);
    },

    createNew(map) {
      this.$emit("createNew");
    },
    savedSuccesfully(){
      this.$emit("saved");
    },
    showAlert(alertData) {
      this.alert = {
        visible: true,
        ...alertData,
      };
    },
    
  },
  props: {
     geometries: {
       required: true
     }
    // showAuthorities: {
    //   required: true
    // },
    // showHeatMapComplaints: {
    //   required: true
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
